
export default function ComparisonCTA() {
  return (
    <section className="py-12 sm:py-16 px-4 sm:px-6">
      <div className="max-w-5xl mx-auto">
        <div className="relative bg-gradient-to-br from-primary to-primary-dark rounded-3xl p-8 sm:p-12 overflow-hidden">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-white rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2"></div>
          </div>

          <div className="relative z-10 text-center">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
              Ainda tem dúvidas?
            </h2>
            <p className="text-white/90 text-base sm:text-lg max-w-2xl mx-auto mb-8">
              Fale diretamente com nosso time e descubra qual plano é ideal para o seu negócio. 
              Demonstração gratuita e sem compromisso.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="https://wa.me/5541992584018?text=Olá! Gostaria de tirar algumas dúvidas sobre os planos da NeuroAgents."
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto bg-white hover:bg-gray-100 text-primary px-8 py-4 rounded-xl font-semibold transition-colors flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap shadow-lg"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-lg"></i>
                </div>
                Falar com Consultor
              </a>
              <a
                href="/#faq"
                className="w-full sm:w-auto bg-white/10 hover:bg-white/20 text-white px-8 py-4 rounded-xl font-semibold transition-colors flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap border border-white/20"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-question-line text-lg"></i>
                </div>
                Ver Perguntas Frequentes
              </a>
            </div>

            <div className="mt-10 pt-8 border-t border-white/20">
              <div className="grid sm:grid-cols-3 gap-6 text-center">
                <div>
                  <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-xl mx-auto mb-3">
                    <i className="ri-shield-check-line text-white text-2xl"></i>
                  </div>
                  <p className="text-white font-semibold">7 Dias de Garantia</p>
                  <p className="text-white/70 text-sm">Satisfação garantida ou seu dinheiro de volta</p>
                </div>
                <div>
                  <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-xl mx-auto mb-3">
                    <i className="ri-time-line text-white text-2xl"></i>
                  </div>
                  <p className="text-white font-semibold">Economize 5h/semana</p>
                  <p className="text-white/70 text-sm">Ou devolvemos seu investimento</p>
                </div>
                <div>
                  <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-xl mx-auto mb-3">
                    <i className="ri-close-circle-line text-white text-2xl"></i>
                  </div>
                  <p className="text-white font-semibold">Cancele Quando Quiser</p>
                  <p className="text-white/70 text-sm">Sem multas ou taxas de cancelamento</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
